import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectLoaded, selectLoading, selectSaved, selectSaving, selectError, selectAssessment } from '../selectors/assessment.selector';
import { assessmentActions } from '../actions/assessment.actions';
import { AssessmentValue } from '../models';

@Injectable({
    providedIn: 'root',
})
export class AssessmentFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loading$ = this.store.select(selectLoading);
    readonly saving$ = this.store.select(selectSaving);
    readonly saved$ = this.store.select(selectSaved);
    readonly error$ = this.store.select(selectError);
    readonly assessment$ = this.store.select(selectAssessment);

    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly saving = this.store.selectSignal(selectSaving);
    readonly saved = this.store.selectSignal(selectSaved);
    readonly error = this.store.selectSignal(selectError);
    readonly assessment = this.store.selectSignal(selectAssessment);

    getAssessment(courseId: string): void {
        this.store.dispatch(assessmentActions.getAssessment({ courseId }));
    }

    saveAssessment(courseId: string, value: AssessmentValue): void {
        this.store.dispatch(assessmentActions.saveAssessment({ courseId, value }));
    }

    patchAssessment(id: string, value: AssessmentValue): void {
        this.store.dispatch(assessmentActions.patchAssessment({ id, value }));
    }

    deleteAssessment(id: string): void {
        this.store.dispatch(assessmentActions.deleteAssessment({ id }));
    }

    clear(): void {
        this.store.dispatch(assessmentActions.clear());
    }
}
